[data-group="scolab-switcher"] .env-switcher-label {
    border-radius: 6px;
    background-color: #1C1F21;
    display: flex;
    align-items: center;
    width: 172px;
    height: 40px;
    padding: 4px 8px;
    font-family: "Open Sans", arial, sans-serif;
    position: relative;
}

[data-group="scolab-switcher"] .env-switcher-label div {
    flex: 1;
    justify-content: left;
}

[data-group="scolab-switcher"] .env-switcher-label div > * {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

[data-group="scolab-switcher"] .env-switcher-label label {
    color: #98A1AF;
    height: 12px;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    text-transform: capitalize;
}

[data-group="scolab-switcher"] .env-switcher-label button {
    border: 0;
    margin: 0;
    padding: 0;
    background-color: #1C1F21;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 132px;
    overflow: hidden;
}

[data-group="scolab-switcher"] .scolab-switcher-loading-label {
    cursor: default;
}

[data-group="scolab-switcher"] .scolab-switcher-loading-label div > .scolab-switcher-loading-value {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0;
    width: 100%;
}
